import {useEffect, useState} from "react";
import {EditSubtitles} from "./EditSubtitles";
import {ISubtitles} from "./LocalizedSubtitles";
import {ProjectDetails} from "../../redux/types/firebase";

interface IEditLocalizedSubtitles {
    blockName: string
    language: string
    onChange: (update: ISubtitles) => void
    project: ProjectDetails
    subtitles: ISubtitles
}
export function EditLocalizedSubtitles({blockName, language, onChange, project, subtitles}: IEditLocalizedSubtitles) {
    const [working, setWorking] = useState(subtitles);
    const handleAddCue = () => {
        working.languages[language].cues.push({start: 0, stop: 0, text: ""});
        onChange(working);
    };
    const handleMoveCue = (from: number, to: number) => {
        const replace = working.cues[to];

        working.languages[language].cues[to] = working.cues[from];
        working.languages[language].cues[from] = replace;
        onChange(working);
    };
    const handleUpdateCue = () => {
        onChange(working);
    };
    const handleDeleteCue = (index: number) => {
        working.languages[language].cues.splice(index, 1);
        onChange(working);
    }

    useEffect(() => {
        const working = JSON.parse(JSON.stringify(subtitles));
        
        if (working.languages === undefined) {
            working.languages = {};
        }
        if (working.languages[language] === undefined) {
            working.languages[language] = {
                cues: JSON.parse(JSON.stringify(working.cues))
            }
            onChange(working);
        }
        setWorking(JSON.parse(JSON.stringify(working)));
    }, [language, onChange, subtitles]);
    if (working.languages === undefined || working.languages[language] === undefined) return null;
    return (
        <EditSubtitles blockName={blockName} cues={working.languages[language].cues} onAddCue={handleAddCue}
                       onDeleteCue={handleDeleteCue} onMoveCue={handleMoveCue} onUpdateCue={handleUpdateCue}
                       project={project}/>
    );
}